import { workflowComponent } from '@banking/ui/services/bank-accounts';
import { hbs } from 'ember-cli-htmlbars';
import { userClickCancelBankVerificationAction, userClickContinueBankVerificationAction } from '@banking/ui/workflows/bank-accounts/cancel-verification';
const template = hbs`
  <Banking::BankAccounts::Modal
    @active={{this.showCancelVerificationModal}}
    @closeModal={{this.userClickContinueBankVerification}}
  >
    <Banking::BankAccounts::CancelVerification
      @isCancellingVerification={{this.isCancellingVerification}}
      @userClickContinueVerification={{this.userClickContinueBankVerification}}
      @userClickCancelVerification={{this.userClickCancelVerification}}
    />
  </Banking::BankAccounts::Modal>
`;
export const mapStateToProps = state => ({
  isCancellingVerification: state.cancelVerificationModal.isCancellingVerification,
  showCancelVerificationModal: state.cancelVerificationModal.isModalOpen
});
const mapActionsToProps = () => ({
  userClickContinueBankVerification: userClickContinueBankVerificationAction,
  userClickCancelVerification: userClickCancelBankVerificationAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);